import { Controller } from "@hotwired/stimulus"
import axios from 'axios'

export default class extends Controller {
  send({ params: { eventName, path, location } }) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken
    axios.post('/note/events', {
      event_name: eventName,
      location: location,
      path: path
    })
  }
}
